import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { deleteOperadores } from "../functions";
const OperadoresDelete = ({openDelete,setOpenDelete}) => {
    const { operadoresIdSelected } = useSelector(({ operador }) => operador);
    
    const deleteFnc = async () =>{
        
    await deleteOperadores(operadoresIdSelected)
    setOpenDelete(false);
}
    return (
        <>
            <Dialog
            open={openDelete}
            onClose={()=>setOpenDelete(false)}
            >
                <DialogTitle>
                    <Typography variant="title">{"Eliminar"}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="subtitle">
                        {"Continuar con la Eliminacion del chofer"}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={()=>setOpenDelete(false)} color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button onClick={deleteFnc} color="primary"> 
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default OperadoresDelete;